import { Alert } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LoginOrSignupForm from '../components/Auth/LoginButton';
import { useThemeMode } from '../contexts/ThemeContext';

const LoginPage: React.FC = () => {
  const theme = useTheme();
  const { themeMode } = useThemeMode();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    (location.state?.error as string | undefined) || undefined
  );

  useEffect(() => {
    const sessionError = sessionStorage.getItem('login_error');
    if (sessionError) {
      setErrorMessage(sessionError);
      sessionStorage.removeItem('login_error');
    }
  }, []);

  return (
    // Removed outer Box that handled 100vh and centering.
    // App.js will now manage centering for the login page.
    <Container component="main" maxWidth="sm">
      {errorMessage && (
        <Alert severity="error" sx={{ mt: 4 }}>
          {errorMessage}
        </Alert>
      )}
      <Paper
        elevation={6}
        sx={{
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: 8, // Added some margin top for spacing if App.js centers it.
          backgroundColor: theme.palette.greyLight,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
          <img
            src={
              themeMode === 'dark'
                ? '/Bidlogiq_Logo-Long_Reversed.png'
                : '/Bidlogiq_Logo-Long_Full_colours.png'
            }
            alt="BIDLOGIQ Logo"
            style={{ height: '75px', width: 'auto', marginBottom: '8px' }}
          />
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              letterSpacing: 1,
              textAlign: 'left',
              fontSize: '1.2rem',
            }}
          >
            Log in
          </Typography>
        </Box>
        <LoginOrSignupForm />
      </Paper>

      <Paper
        elevation={1}
        sx={{
          marginTop: 2,
          padding: 2,
          backgroundColor: theme.palette.greyLight,
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontSize: '1rem', color: theme.palette.text.primary }}
        >
          NEWS:
        </Typography>
        <Typography variant="body2" sx={{ fontSize: '0.9rem', color: theme.palette.text.primary }}>
          Welcome to BIDLOGIQ! We're here to create the best platform for you, so please let us know
          if you have any problems, feature requests, feedback, or suggestions. We will do our best
          to implement features as fast as possible. Thanks!{' '}
          <a href="mailto:support@bidlogiq.ai">support@bidlogiq.ai</a>.
        </Typography>
      </Paper>

      <Paper
        elevation={1}
        sx={{
          marginTop: 2,
          padding: 2,
          backgroundColor: theme.palette.greyLight,
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontSize: '1rem', color: theme.palette.text.primary }}
        >
          NEED AN ACCOUNT?
        </Typography>
        <Typography variant="body2" sx={{ fontSize: '0.9rem', color: theme.palette.text.primary }}>
          Registration is currently invite-only. To request an account or schedule a demo, please
          contact our team at <a href="mailto:sales@bidlogiq.ai">sales@bidlogiq.ai</a>.
        </Typography>
      </Paper>
    </Container>
  );
};

export default LoginPage;
